var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgArchive = function SvgArchive(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_3725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10.75L8.58333 8.41667L7.76667 7.6L6.83333 8.53333V6.08333H5.66667V8.53333L4.73333 7.6L3.91667 8.41667L6.25 10.75ZM2.16667 4.91667V11.3333H10.3333V4.91667H2.16667ZM2.16667 12.5C1.84583 12.5 1.57118 12.3858 1.34271 12.1573C1.11424 11.9288 1 11.6542 1 11.3333V4.05625C1 3.92014 1.02187 3.78889 1.06562 3.6625C1.10938 3.53611 1.175 3.41944 1.2625 3.3125L1.99167 2.42292C2.09861 2.28681 2.23229 2.18229 2.39271 2.10938C2.55313 2.03646 2.72083 2 2.89583 2H9.60417C9.77917 2 9.94687 2.03646 10.1073 2.10938C10.2677 2.18229 10.4014 2.28681 10.5083 2.42292L11.2375 3.3125C11.325 3.41944 11.3906 3.53611 11.4344 3.6625C11.4781 3.78889 11.5 3.92014 11.5 4.05625V11.3333C11.5 11.6542 11.3858 11.9288 11.1573 12.1573C10.9288 12.3858 10.6542 12.5 10.3333 12.5H2.16667ZM2.4 3.75H10.1L9.60417 3.16667H2.89583L2.4 3.75Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_3725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArchive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Archive.beeba975.svg";
export { ForwardRef as ReactComponent };